import { useState } from 'react'
import { bindAuthApi, getGoogleInfo } from '@/api/common'
import { BindAuthRes } from '@/types/api'
import { SUCCESS_CODE } from '@/utils/constants'
import { useGoogleLogin } from '@react-oauth/google'
import { baiduRegisterEvent } from '@/utils'
import { gtagRegisterEvent } from '@/utils/gtagEvent'
import { getBdVid, getPromotionInfo } from './useBdVid'
import { qhTrackRegister } from '@/utils/track'

interface Props {
  onBindSuccess?: (data: BindAuthRes) => void
  onBindError?: () => void
  invite_code: string
}

// Google认证，用于登录/注册/绑定
const useGoogleAuth = (props: Props) => {
  const { onBindSuccess, onBindError, invite_code } = props
  const { qhclickid } = getBdVid()
  const [isLoading, setIsLoading] = useState(false)
  const promotionInfo = getPromotionInfo()

  const handleSuccess = (tokenResponse: any) => {
    setIsLoading(true)
    getGoogleInfo(tokenResponse.access_token)
      .then((res) => {
        const userInfo = res?.data
        return bindAuthApi('google', {
          id: userInfo?.sub,
          nickname: userInfo?.name,
          name: userInfo?.name,
          email: userInfo?.email,
          avatar: userInfo?.picture,
          user: userInfo,
          invite_code,
          ...promotionInfo
        })
      })
      .then((bindRes) => {
        setIsLoading(false)
        if (bindRes?.data?.code === SUCCESS_CODE) {
          console.log('bindRes?.data?.data', JSON.stringify(bindRes?.data?.data))
          if (bindRes?.data?.data?.event_type === 'signup') {
            baiduRegisterEvent()
            // qhTrackRegister({
            //   qhclickid,
            //   id: bindRes?.data?.data?.user?.user_id
            // })
            gtagRegisterEvent()
          }
          onBindSuccess?.(bindRes?.data?.data)
        } else {
          onBindError?.()
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  const googleAuth = useGoogleLogin({
    onSuccess: handleSuccess,
    onError: (errorResponse) => console.log(errorResponse)
  })

  return {
    googleAuth,
    isLoading
  }
}

export default useGoogleAuth
